import { Modal } from "antd";
import "./styles.scss";
import "./confirm.scss";
import React from "react";
import { withTranslation, useTranslation } from "react-i18next";

// O'zgarishlarni saqlash tasdig'i: Saqlash / O'zgarishlarni bekor qilish / Yopish
function SaveModal(props) {
  const { t } = useTranslation();

  return (
    <Modal
      className="ln-confirm"
      open={props.show}
      onCancel={() => props.closeShow()}
      footer={null}
      centered
      width={460}
    >
      <div className="ln-confirm__body">
        <span className="ln-confirm__icon">
          <i className="bx bx-save" />
        </span>
        <h3 className="ln-confirm__title">{t("Save the changes?")}</h3>
        <p className="ln-confirm__text">{t("ln_save_changes_text")}</p>
        <div className="ln-confirm__actions">
          <button type="button" className="ln-confirm__btn ln-confirm__btn--primary" onClick={() => props.handleok()}>
            <i className="bx bx-check" />
            {t("Save")}
          </button>
          <button type="button" className="ln-confirm__btn ln-confirm__btn--danger" onClick={() => props.handleCancel()}>
            {t("Cancel_update")}
          </button>
          <button type="button" className="ln-confirm__btn ln-confirm__btn--ghost" onClick={() => props.closeShow()}>
            {t("Cancel")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default withTranslation()(SaveModal);
